export default __webpack_public_path__ + "static/media/ip.77d0dff8.svg";